import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import IconDrag from '../../../../media/images/drag.svg'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { deleteMeetings, getAgenda, getMeetings, getParticipants } from '../core/_requests'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { getFileType, sanitizeFileName, toTitleCase } from '../core/_util'
import Skeleton from 'react-loading-skeleton'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { useIntl } from 'react-intl'
import { useTimeZone } from '../../../hooks/useTimeZone'

export const MeetingInterface = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const meetingId = searchParams.get('meetingId')
  const [agendaData, setAgendaData] = useState<any>([])
  const [participantsData, setParticipantsData] = useState<any>([])
  const [meetingDetails, setMeetingDetails] = useState<any>()
  const [organizer, setOrganizer] = useState<any>()
  const [loading, setLoading] = useState(false)
  const { getDateValue } = useDateFormat()
  const { getTimeZoneValue } = useTimeZone()
  const getMeetingAgenda = async () => {
    if (!meetingId)
      return
    try {
      const {
        data: { success, data },
      } = await getAgenda(meetingId, true)
      if (success) {
        setAgendaData(data.data)
      }
    } catch (err) {
      console.log(err)
    }
  }
  const getMeetingParticipant = async () => {
    if (!meetingId)
      return
    try {
      const {
        data: { success, data },
      } = await getParticipants(meetingId, true)
      if (success) {
        const responseData = data.data.map((item: any) => {
          let badge;
          if (item.type === 'Host')
            badge = 'primary';
          else if (item.type === 'Guest')
            badge = 'warning';
          else if (item.type === 'Observer')
            badge = 'success';
          else if (item.type === 'Organizer')
            badge = 'info'
          else if (item.type === 'Participant')
            badge = 'danger'
          else
            badge = 'secondary'

          return {
            ...item,
            badge
          };
        });
        setParticipantsData(responseData)
        setOrganizer(data.data.find((item: any) => item.type === 'Organizer'))
      }
    } catch (err) {
      console.log(err)
    }
  }
  const getMeetingDetails = async () => {
    if (!meetingId)
      return
    try {
      const {
        data: { success, data },
      } = await getMeetings(meetingId)

      if (success) {
        setMeetingDetails(data)
      }
    } catch (err) {
      console.log(err)
    }
  }
  const apiCalling = async () => {
    if (meetingId) {
      await getMeetingDetails()
      await getMeetingAgenda()
      await getMeetingParticipant()
      setLoading(true)
    }
  }
  useEffect(() => {
    apiCalling()
  }, [meetingId])// eslint-disable-line react-hooks/exhaustive-deps
  const cancelMeeting = async () => {
    if (!meetingId)
      return
    try {
      const {
        data: { success },
      } = await deleteMeetings(meetingId)
      if (success) {
        navigate(`/compliance-meeting`)
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className='bg-white rounded-2 p-4 mb-6'>
      {!loading ?
        <>
          <Skeleton
            height={40}
            count={1}
            width={'50%'}
            className='my-2'
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
          <Skeleton
            height={40}
            count={1}
            width={'50%'}
            className='mt-5 my-2'
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
          <Skeleton
            height={40}
            count={1}
            width={'50%'}
            className='mt-5 my-2'
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
          <Skeleton
            height={40}
            count={1}
            width={'50%'}
            className='mt-5 my-2'
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
          <Skeleton
            height={500}
            count={1}
            width={'100%'}
            className='mt-5 my-2'
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
        </>
        :
        <>
          <div className='d-flex flex-column flex-md-row justify-content-between align-items-start'>
            <div>
              <h2>{toTitleCase(meetingDetails?.meetingTitle)} | {toTitleCase(meetingDetails?.category)}</h2>
              <p>{getDateValue(meetingDetails?.meetingDate.toString())} {` |  ${getTimeZoneValue(meetingDetails?.startTime.toString())}`}
              </p>
            </div>
            <div className='d-flex flex-column flex-md-row gap-2 w-100 w-md-auto'>
              <button className='btn btn-light w-100 w-md-auto mt-2 mt-md-0' onClick={cancelMeeting} type='button'>{formatMessage({ id: 'Cancel Meeting' })}</button>
              <Link to={`../view/add-board-meeting?tab=${sanitizeFileName(meetingDetails?.category).toLowerCase()}&meetingId=${meetingDetails?.meetingId}`}>
                <button className='btn btn-primary w-100 w-md-auto mt-2 mt-md-0'>{formatMessage({ id: 'Edit Meeting' })}</button>
              </Link>

            </div>
          </div>

          <div className='d-flex flex-row'>
            {meetingDetails?.venue &&
              <div className='mt-5 w-50'>
                <h5>{formatMessage({ id: 'Meeting Venue' })}</h5>
                <p className='text-primary cursor-pointer'>{meetingDetails?.venue}</p>
                <a href={meetingDetails?.link} target='_blank' rel="noreferrer">
                  <button className='btn btn-primary w-100 w-md-auto'>{formatMessage({ id: 'Get Direction' })}</button>
                </a>
              </div>
            }
            <div className='mt-5'>
              <h5>{formatMessage({ id: 'Meeting URL' })}</h5>
              <p className='text-primary cursor-pointer'>{meetingDetails?.link}</p>
              {/* <button className='btn btn-primary w-100 w-md-auto'>Start Meeting</button> */}
            </div>
          </div>

          <div className='mt-5'>
            <h5>{formatMessage({ id: "Organizer" })}</h5>
            <div className='d-flex'>
              <DisplayImage
                imgName={organizer && organizer.profileImage.name ? organizer.profileImage.name : 'dummy'}
                alt='profile'
                fit='cover'
                className='rounded-circle'
                width={32}
                height={32}
              />

              {!organizer ?
                <Skeleton
                  height={10}
                  count={1}
                  width={'50%'}
                  className='my-2'
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                :
                <div className='ms-4'><p className='m-0'>{toTitleCase(organizer?.name)}</p>
                  <p className='m-0'>{organizer?.isGuest ? 'Guest' : 'Shareholder'}</p></div>
              }
            </div>
          </div>
          {meetingDetails?.description && <div className='mt-4'>
            <h5>{formatMessage({ id: 'Description' })}</h5>
            <p className='text-muted'>
              {meetingDetails?.description}
            </p>
          </div>}

          {meetingDetails?.notes && <div className='mt-4'>
            <h5>{formatMessage({ id: "Notes for participants" })}</h5>
            <p className='text-muted'>
              {meetingDetails?.notes}
            </p>
          </div>}

          <Row>
            <Col md={6} sm={12}>
              <div
                className='border border-1 p-4 rounded-2 mt-4'
                style={{ height: '400px', overflow: 'hidden' }}
              >
                <div className='d-flex justify-content-between align-items-center'>
                  <h5 className='mt-2 mb-4'>{formatMessage({ id: "Agenda" })}</h5>
                </div>
                <div className='seperator bg-dark border'></div>

                <div className='mt-2' style={{ overflowY: 'auto', maxHeight: '330px' }}>
                  {agendaData.map((agenda: any) => (
                    <div className='d-flex align-items-center justify-content-between pt-4' key={agenda.agendaId}>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center gap-2'>
                          <img src={IconDrag} alt='Drag sequence icon' width={32} height={32} />
                          <div className=''>
                            <p className='mb-0 font-size-13'>{toTitleCase(agenda.agendaTitle)}</p>
                            <div className='d-flex align-items-center gap-6'>
                              <p className='mb-0 font-size-12 text-muted'>{agenda.assignedTime}</p>
                              {agenda.presenter && <p className='mb-0 font-size-12 text-muted'>
                                {toTitleCase(agenda.presenter)}
                              </p>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='d-flex align-items-center'>
                        {agenda?.AgendaDocuments.map((doc: any) => (
                          <>
                            <img
                              key={doc.documentsId}
                              src={getFileType(doc.file.name)}
                              alt='Document icon'
                              width={32}
                              height={32}
                            />
                          </>
                        ))}
                      </div>
                    </div>
                  ))}
                  {/* Add more participants here to test scrolling */}
                </div>
              </div>
            </Col>
            <Col md={6} sm={12}>
              <div
                className='border border-1 p-4 rounded-2 mt-4'
                style={{ height: '400px', overflow: 'hidden' }}
              >
                <div className='d-flex justify-content-between align-items-center'>
                  <h5 className='mt-2 mb-4'>{formatMessage({ id: 'Participants' })} ({participantsData?.length})</h5>
                </div>
                <div className='seperator bg-dark border'></div>

                <div className='mt-2' style={{ overflowY: 'auto', maxHeight: '330px' }}>
                  {participantsData.map((participant: any) => (
                    <div className='d-flex align-items-center justify-content-between pt-4' key={participant.meetingParticipantId}>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center gap-2'>
                          <DisplayImage
                            imgName={participant.profileImage.name ? participant.profileImage.name : 'dummy'}
                            alt='profile'
                            fit='cover'
                            className='rounded-circle'
                            width={32}
                            height={32}
                          />
                          <div className=''>
                            <p className='mb-0 font-size-13'>{toTitleCase(participant.name)}</p>
                            <p className='mb-0 font-size-12 text-muted'>{participant.isGuest ? 'Guest' : 'Shareholder'}</p>
                          </div>
                        </div>
                      </div>
                      <div className={`badge alert-${participant.badge} px-4 py-2`}>{participant.type}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </>
      }
    </div>
  )
}

export default MeetingInterface
